import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ContractorLocationForm from './ContractorLocationForm';
import { EditPage } from '../edit_page/EditPage';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../../thunks/contractor_clients_thunks';

const NewContractorLocationPage: FC<any> = ({
	history,
	userType,
	match,
	fetching,
	getContractorClient,
	contractorClient,
}): React.ReactElement => {
	const contractorClientId = parseInt(match.params.id);

	useEffect(() => {
		getContractorClient(contractorClientId);
	}, [contractorClientId]);

	return (
		<EditPage
			title="New Location"
			formComponentProps={{
				formData: {
					contractorClientId,
					contractorClient,
				},
				onSuccess: (rec) =>
					history.push(`/${userType}/contractor_clients/locations/detail/${rec.id}`),
			}}
			fetching={fetching}
			FormComponent={ContractorLocationForm}
		/>
	);
};

const mapStateToProps = (state) => ({
	contractorClient: state.contractor_clients.detail,
	fetching: state.contractor_clients.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getContractorClient: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorClientsRestCrudThunksForSupplier.readOne(id)
				: contractorClientsRestCrudThunksForBuyer.readOne(id)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(NewContractorLocationPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
